export const environment = {
    production: true,
    baseUrl: ".",
    baseUrlStorage:".",
    baseUrlBrowser: "./nbrowser",
    NgasaUrl:"./stop-execution",
    baseUrlAiops: "./aiops",
    baseUrlAiAutomation: "http://192.168.8.225:8001",
    basedUrl:"http://192.168.4.39:8085"
};